module.exports = __webpack_public_path__ + "static/media/Trapezium.32d9b1e7.jpg";